import { type ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Card } from './Card';
import { cn } from '../utils';

export interface AddCardProps {
  label: ReactNode;
  description?: ReactNode;
  icon?: IconDefinition;
  onPress?: () => void;
  isDisabled?: boolean;
  title?: string;
  className?: string;
}

export const AddCard = ({
  label,
  description,
  icon = faPlus,
  onPress,
  isDisabled = false,
  title,
  className
}: AddCardProps) => (
  <button
    type="button"
    onClick={onPress}
    disabled={isDisabled}
    title={title}
    className="group block h-full w-full text-left">
    <Card
      className={cn(
        'flex h-full flex-row items-center justify-center gap-3 border-2 border-dashed border-default-400 bg-content1/60 p-4 text-center shadow-none',
        'transition-colors duration-150',
        isDisabled
          ? 'cursor-not-allowed opacity-60'
          : 'hover:border-(--ark-color-accent) hover:bg-[color-mix(in_oklab,var(--ark-color-accent)_12%,transparent)]',
        className
      )}>
      <span
        className={cn(
          'grid h-9 w-9 flex-none place-items-center rounded-full bg-[color-mix(in_oklab,var(--ark-color-accent)_18%,transparent)] text-base text-(--ark-color-accent) transition-colors',
          !isDisabled && 'group-hover:bg-(--ark-color-accent) group-hover:text-[#1a1206]'
        )}>
        <FontAwesomeIcon icon={icon} />
      </span>
      <span className="text-sm font-semibold text-foreground">{label}</span>
      {description && <span className="text-xs text-default-500">{description}</span>}
    </Card>
  </button>
);
